import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthUser, selectCreditCards } from '../../reducers/auth/auth.selectors';
import AddPaymentModal from '../../components/AddPaymentModal';
import { selectIsFollowingProfile } from '../../reducers/profile/profile.selectors';
import Loader from '../../components/Loader';
import { fetchProfile, toggleFollow } from '../../reducers/profile/profile.actions';
import { getLaravelValidationErrors } from '../../helpers';
import LoginModal from '../../components/LoginModal';
import FollowBenefits from '../../components/FollowBenefits';

const SubscribeModal = ({ user, isOpen, setIsOpen, btn }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const creditCards = useSelector(selectCreditCards);
  const isFollowingProfile = useSelector(selectIsFollowingProfile);
  const currentUser = useSelector(selectAuthUser);
  const [isLoading, setIsLoading] = useState(false);
  //const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useState([]);
  const toggleSubscribe = () => {
    setIsOpen(true);
  };
  const onSubmit = () => {
    if (!isLoading) {
      setIsLoading(true);
      dispatch(toggleFollow(user.id))
        .then(rest => {
          handleClose();
        })
        .catch(err => {
          console.log('toggleFollow error', err);
          setErrors(getLaravelValidationErrors(err));
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };
  const handleClose = () => {
    setIsOpen(false);
    setErrors([]);
  };
  //console.log(isOpen, user, currentUser, creditCards);
  if (!user || (currentUser && user.id === currentUser.id)) return <></>;
  return (
    <>
      {btn !== false && (
        <Button
          type="submit"
          className="btn btn-primary  d-flex align-items-center  text-uppercase text-white  ml-3"
          style={{ borderRadius: '32px' }}
          onClick={toggleSubscribe}
        >
          <Loader isLoadin={isLoading} height={30} size={30}>
            {isFollowingProfile
              ? t('unsubscribe')
              : t('Subscribe for ') + (user.subscriptionPrice > 0 ? '$' + user.subscriptionPrice : t('free'))}
          </Loader>
        </Button>
      )}
      {!!currentUser ? (
        !!creditCards.length ? (
          <Modal show={isOpen && !!user} onHide={handleClose} centered size="md">
            <Modal.Header closeButton>
              <Modal.Title className="d-flex align-items-center text-primary">
                {t(isFollowingProfile ? 'Unsubscribe' : 'Subscribe')}
              </Modal.Title>
            </Modal.Header>
            {!isFollowingProfile && <FollowBenefits user={user} />}
            <Modal.Body>
              <Loader isLoadin={isLoading} height={80} size={60}>
                {!isFollowingProfile ? (
                  <h5 className="text-gray mt-2 ml-1 text-center">
                    {t('Subscribe to %user for %amount ')
                      .replace('%user', user.name)
                      .replace(
                        '%amount',
                        user.subscriptionPrice > 0 ? '$' + user.subscriptionPrice + t(' per month ') : t('free ')
                      )}
                  </h5>
                ) : (
                  <>
                    <pre style={{ fontFamily: 'inherit' }}>
                      <p className="h4 text-black">{t('Are you sure you want to cancel \nSubscription?')}</p>
                    </pre>
                    <Form.Group controlId="exampleForm.ControlSelect1">
                      <Form.Label>{t('Reason for Cancellation')}</Form.Label>
                      <Form.Control as="select" size="lg">
                        <option>{t('No specific reason')}</option>
                        <option>{t('Private messages not replied')}</option>
                        <option>{t('No longer want to be subscribed')}</option>
                        <option>{t('Subscription price too high')}</option>
                        <option>{t('Will re-subscribe later')}</option>
                      </Form.Control>
                    </Form.Group>
                  </>
                )}
                {!!errors.length &&
                  errors.map((err, key) => (
                    <p key={key} className="text-danger py-1">
                      {err}
                    </p>
                  ))}
                <div className="d-flex align-items-center mt-5">
                  <p
                    className="d-flex align-self-center cursor-pointer ml-auto mr-5 text-light-gray p-2"
                    onClick={handleClose}
                  >
                    {t('Cancel')}
                  </p>
                  <Button onClick={onSubmit} className="btn btn-light px-5" style={{ borderRadius: '32px' }}>
                    {t(isFollowingProfile ? 'Unsubscribe' : 'Subscribe')}
                  </Button>
                </div>
              </Loader>
            </Modal.Body>
          </Modal>
        ) : (
          <AddPaymentModal user={user} show={isOpen} onHide={handleClose} />
        )
      ) : (
        <LoginModal
          user={user}
          show={isOpen}
          onHide={handleClose}
          callback={() => {
            dispatch(fetchProfile(user.id)).catch(err => {
              console.log('fetch user error', err);
            });
          }}
        />
      )}
    </>
  );
};

export default SubscribeModal;
